import { logger } from '@/ui/utilities/instrumentation/logger'
import ctl from '@netlify/classnames-template-literals'
import type { DashboardCampaignModel, DashboardViewModel } from './dashboard.vm'

type CtaButtonProps = {
	linkRenderer: DashboardViewModel['renderers']['campaignLink']
	campaign: DashboardCampaignModel
	label: string
}

export function CtaButton({ linkRenderer, campaign, label }: CtaButtonProps) {
	const handleCtaClick = () => {
		logger.track('Dashboard: CTA clicked', {
			data: {
				campaign_id: campaign.id,
				campaign_status: campaign.status,
				cta_label: label,
			},
		})
	}

	const isViewCandidatesCta = campaign.status !== 'draft' && campaign.status !== 'review'
		&& campaign.status !== 'publishing'

	return (
		<>
			{linkRenderer(campaign.id, campaign.status, campaign.isArchived, {
				className: 'block w-full',
				children: (
					<span
						className={ctl(`
							flex items-center justify-between gap-1 w-full text-lg
							text-purple-950/60 font-bold bg-purple-100 px-3.5 py-3
							hover:bg-purple-200 transition-colors
						`)}
						onClick={handleCtaClick}
					>
						<span>{label}</span>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={1.5}
							stroke="currentColor"
							className="size-4 shrink-0"
						>
							<path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
						</svg>
					</span>
				),
			}, isViewCandidatesCta ? 'candidates' : undefined)}
		</>
	)
}
